import InventoryItemInterface from 'app/interfaces/InventoryItemInterface';

const BET_ITEM_TYPES = [
    'artifact',
    'scroll_artifact',
    'scroll_entry'
];

type BetItemCandidate = Pick<InventoryItemInterface, 'item_type' | 'bet_available'> | null | undefined;

export const isBetItem = (item: BetItemCandidate): boolean => BET_ITEM_TYPES.includes(item?.item_type || '') &&
    Boolean(item?.bet_available);
